import React from 'react';
import "./App.css";
import Weather from "./Weather";

export default function App() {
  return (
    <div className="container">
    <div className="App">
            <div className="card">
            <Weather defaultCity ="Tokyo" />
            </div>
    
            <p className="source-code">
            <hr />
            This project was coded by{" "}
            <a
                  href="https://www.linkedin.com/in/lisaroux/"
                  target="_blank"
                  rel="noreferrer"
                >
                Lisa Roux 🌸  {" "}
                </a>
                and is{" "}
                <a
                  href="https://github.com/lilisimpson/weather-react"
                  target="_blank"
                  rel="noreferrer"
                >
                   open-sourced on GitHub{" "}
                </a>
                 and{" "}
                <a
                  href="https://gracious-jackson-8d8899.netlify.app"
                  target="_blank"
                  rel="noreferrer"
                >
                 hosted on Netlify
                </a>
          </p>
              
           </div>
         </div>
  );
}